import { render, staticRenderFns } from "./hoyesyellow.vue?vue&type=template&id=33002c0f&scoped=true"
import script from "./hoyesyellow.vue?vue&type=script&lang=js"
export * from "./hoyesyellow.vue?vue&type=script&lang=js"
import style0 from "./hoyesyellow.vue?vue&type=style&index=0&id=33002c0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33002c0f",
  null
  
)

export default component.exports